// frontend/src/components/Layout/AuthLayout.tsx
import React, { useState } from 'react';

import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';





// Simple Auth Layout Wrapper
interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
     <PublicHeader variant="full" showAuthButtons={true} />

      
      <div className="flex-1 flex">
        {/* Left Side Info - Hidden on mobile, visible on desktop */}
        <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 to-blue-800 relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-black bg-opacity-20"></div>
          <div 
            className="absolute inset-0" 
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M40 40V20h-20V0H0v20h20v20z'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: '40px 40px'
            }}
          ></div>
          
          {/* Content */}
          <div className="relative z-10 flex flex-col justify-center px-12">
            <div className="max-w-md">
              <div className="flex items-center mb-8">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center mr-4">
                  <span className="text-white font-bold text-lg">AMA</span>
                </div>
                <span className="text-2xl font-bold text-white">Atmyarea</span>
              </div>
              
              <h1 className="text-3xl font-bold text-white mb-4">
                Connect with Trusted Service Providers
              </h1>
              <p className="text-blue-100 text-lg mb-8">
                Join thousands of customers and service providers who trust QuickFix for their daily needs.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center text-blue-100">
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Verified and trusted service providers</span>
                </div>
                <div className="flex items-center text-blue-100">
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Quick and easy booking process</span>
                </div>
                <div className="flex items-center text-blue-100">
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>24/7 customer support</span>
                </div>
                <div className="flex items-center text-blue-100">
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Secure payments and guarantees</span>
                </div>
              </div>

              {/* Stats */}
              <div className="mt-12 grid grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-2xl font-bold text-white">10K+</div>
                  <div className="text-blue-200 text-sm">Happy Customers</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-white">500+</div>
                  <div className="text-blue-200 text-sm">Service Providers</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-white">50+</div>
                  <div className="text-blue-200 text-sm">Services</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form Content */}
        <div className="flex-1 lg:w-1/2 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
          <div className="w-full max-w-md">
            {/* Mobile Logo - Only show on mobile when left side is hidden */}
            <div className="lg:hidden text-center mb-8">
              <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                  <span className="text-white font-bold">AMA</span>
                </div>
                <span className="text-2xl font-bold text-gray-900">Atmyarea</span>
              </div>
              <p className="text-gray-600">Connect with trusted service providers</p>
            </div>

            {/* Your existing auth form content goes here */}
            {children}
          </div>
        </div>
      </div>
      
    

      <PublicFooter variant="full" />


    </div>
  );
};

export default AuthLayout;